import { useEffect, useState } from 'react';

export function useServiceMode(defaultMode = "pickup") {
    const [mode, setMode] = useState(defaultMode);

    useEffect(() => {
        if (typeof window === "undefined") return;
        const read = () => setMode(localStorage.getItem("serviceMode") || defaultMode);

        read();
        const onStorage = (e) => { if (e.key === "serviceMode") read(); };
        const onCustom = () => read();

        window.addEventListener("storage", onStorage);
        window.addEventListener("serviceModeChanged", onCustom);
        return () => {
            window.removeEventListener("storage", onStorage);
            window.removeEventListener("serviceModeChanged", onCustom);
        };
    }, [defaultMode]);

    return mode;
}